/**
 * @fileoverview Contact field state and company-profile sync for Contact Information.
 */

import { useEffect, useState } from "react";
import { getCompanyFieldValue } from "../../../utils/common";

function applyCompanyContactFields({
  company,
  selectedProfile,
  handleFieldChange,
  setTelefonoDeOficina,
  setExtensionTelefono,
  setTelefonoSecundario,
  setCorreoElectronicoPrincipal,
  setPaginaInternet,
  setSelectedCountryCode,
  setSelectedSecondaryCountryCode,
  setShowOfficePhone,
  setShowExtension,
  setShowSecondaryPhone,
  setShowEmail,
  setShowWebsite,
}) {
  const telefono = getCompanyFieldValue(
    company,
    "telefonoDeOficina",
    selectedProfile,
    "",
  );
  setTelefonoDeOficina(telefono);
  handleFieldChange("telefonoDeOficina", telefono);

  const extension = getCompanyFieldValue(
    company,
    "extensionTelefono",
    selectedProfile,
    "",
  );
  setExtensionTelefono(extension);
  handleFieldChange("extensionTelefono", extension);

  const telefonoSec = getCompanyFieldValue(
    company,
    "telefonoSecundario",
    selectedProfile,
    "",
  );
  setTelefonoSecundario(telefonoSec);
  handleFieldChange("telefonoSecundario", telefonoSec);

  const correo = getCompanyFieldValue(
    company,
    "correoElectronicoPrincipal",
    selectedProfile,
    "",
  );
  setCorreoElectronicoPrincipal(correo);
  handleFieldChange("correoElectronicoPrincipal", correo);

  const pagina = getCompanyFieldValue(
    company,
    "paginaInternet",
    selectedProfile,
    "",
  );
  setPaginaInternet(pagina);
  handleFieldChange("paginaInternet", pagina);

  // Update country codes and toggles
  setSelectedCountryCode(
    getCompanyFieldValue(
      company,
      "telefonoDeOficinaCodigoPais",
      selectedProfile,
      null,
    ),
  );
  setSelectedSecondaryCountryCode(
    getCompanyFieldValue(
      company,
      "telefonoSecundarioCodigoPais",
      selectedProfile,
      null,
    ),
  );
  setShowOfficePhone(
    getCompanyFieldValue(
      company,
      "mostrarTelefonoDeOficina",
      selectedProfile,
      false,
    ),
  );
  setShowExtension(
    getCompanyFieldValue(
      company,
      "mostrarExtensionTelefono",
      selectedProfile,
      false,
    ),
  );
  setShowSecondaryPhone(
    getCompanyFieldValue(
      company,
      "mostrarTelefonoSecundario",
      selectedProfile,
      false,
    ),
  );
  setShowEmail(
    getCompanyFieldValue(
      company,
      "mostrarCorreoElectronicoPrincipal",
      selectedProfile,
      false,
    ),
  );
  setShowWebsite(
    getCompanyFieldValue(
      company,
      "mostrarPaginaInternet",
      selectedProfile,
      false,
    ),
  );
}

export function useContactInformationFieldState({
  company,
  selectedProfile,
  handleFieldChange,
}) {
  const [telefonoDeOficina, setTelefonoDeOficina] = useState(
    getCompanyFieldValue(company, "telefonoDeOficina", selectedProfile, ""),
  );
  const [extensionTelefono, setExtensionTelefono] = useState(
    getCompanyFieldValue(company, "extensionTelefono", selectedProfile, ""),
  );
  const [telefonoSecundario, setTelefonoSecundario] = useState(
    getCompanyFieldValue(company, "telefonoSecundario", selectedProfile, ""),
  );
  const [correoElectronicoPrincipal, setCorreoElectronicoPrincipal] = useState(
    getCompanyFieldValue(
      company,
      "correoElectronicoPrincipal",
      selectedProfile,
      "",
    ),
  );
  const [paginaInternet, setPaginaInternet] = useState(
    getCompanyFieldValue(company, "paginaInternet", selectedProfile, ""),
  );
  const [selectedCountryCode, setSelectedCountryCode] = useState(
    getCompanyFieldValue(
      company,
      "telefonoDeOficinaCodigoPais",
      selectedProfile,
      null,
    ),
  );
  const [selectedSecondaryCountryCode, setSelectedSecondaryCountryCode] =
    useState(
      getCompanyFieldValue(
        company,
        "telefonoSecundarioCodigoPais",
        selectedProfile,
        null,
      ),
    );
  const [showOfficePhone, setShowOfficePhone] = useState(
    getCompanyFieldValue(
      company,
      "mostrarTelefonoDeOficina",
      selectedProfile,
      false,
    ),
  );
  const [showExtension, setShowExtension] = useState(
    getCompanyFieldValue(
      company,
      "mostrarExtensionTelefono",
      selectedProfile,
      false,
    ),
  );
  const [showSecondaryPhone, setShowSecondaryPhone] = useState(
    getCompanyFieldValue(
      company,
      "mostrarTelefonoSecundario",
      selectedProfile,
      false,
    ),
  );
  const [showEmail, setShowEmail] = useState(
    getCompanyFieldValue(
      company,
      "mostrarCorreoElectronicoPrincipal",
      selectedProfile,
      false,
    ),
  );
  const [showWebsite, setShowWebsite] = useState(
    getCompanyFieldValue(company, "mostrarPaginaInternet", selectedProfile, false),
  );

  useEffect(() => {
    applyCompanyContactFields({
      company,
      selectedProfile,
      handleFieldChange,
      setTelefonoDeOficina,
      setExtensionTelefono,
      setTelefonoSecundario,
      setCorreoElectronicoPrincipal,
      setPaginaInternet,
      setSelectedCountryCode,
      setSelectedSecondaryCountryCode,
      setShowOfficePhone,
      setShowExtension,
      setShowSecondaryPhone,
      setShowEmail,
      setShowWebsite,
    });
  }, [
    company?.telefonoDeOficina,
    company?.extensionTelefono,
    company?.telefonoSecundario,
    company?.correoElectronicoPrincipal,
    company?.paginaInternet,
    company?.perfiles,
    selectedProfile,
  ]);

  return {
    telefonoDeOficina,
    setTelefonoDeOficina,
    extensionTelefono,
    setExtensionTelefono,
    telefonoSecundario,
    setTelefonoSecundario,
    correoElectronicoPrincipal,
    setCorreoElectronicoPrincipal,
    paginaInternet,
    setPaginaInternet,
    selectedCountryCode,
    setSelectedCountryCode,
    selectedSecondaryCountryCode,
    setSelectedSecondaryCountryCode,
    showOfficePhone,
    setShowOfficePhone,
    showExtension,
    setShowExtension,
    showSecondaryPhone,
    setShowSecondaryPhone,
    showEmail,
    setShowEmail,
    showWebsite,
    setShowWebsite,
  };
}
